import styled, { css } from 'styled-components'

export const Container = styled.div<{
  $enableHeaderPadding: boolean
  $fillHeight: boolean
  $fullWidth: boolean
}>`
  width: 100%;
  min-height: 100%;
  // restrict background to Header and Footer when fullWidth is true
  // - HeaderSpacer and Footer both set this background color as well
  box-sizing: border-box;
  ${({ $fillHeight }) =>
    $fillHeight &&
    css`
      height: 100%;
    `}

  ${({ $enableHeaderPadding }) =>
    $enableHeaderPadding &&
    css`
      --nav-fixed-height: 122px;
      @media (min-width: 576px) {
        --nav-fixed-height: 122px;
      }

      @media (min-width: 768px) {
        --nav-fixed-height: 158px;
      }

      @media (min-width: 992px) {
        --nav-fixed-height: 133px;
      }

      @media (min-width: 1200px) {
        --nav-fixed-height: 135px;
      }

      // offset scroll position for inner document links
      a:not([href]):not([tabindex]),
      [id] {
        scroll-margin-top: 75px;
      }
    `};

  @media print {
    background: unset;
    padding-top: unset;
  }
`

export const SkipNavigationLink = styled.a`
  position: absolute;
  top: -60px;
  left: 1em;
  z-index: 1000;
  color: ${({ theme }) => theme.colors.grayscale.white};

  &:focus {
    top: 15px;
  }
`

export const PageContainer = styled.div<{
  $fillHeight: boolean
  $fullWidth: boolean
  $useIncreasedWidth: boolean
}>`
  width: 100%;
  min-width: 320px;
  ${({ $fullWidth, $useIncreasedWidth }) =>
    !$fullWidth &&
    css`
      max-width: ${$useIncreasedWidth ? '1440px' : '1280px'};
    `};
  ${({ $fillHeight }) =>
    $fillHeight &&
    css`
      height: 100%;
    `}

  position: relative;
  margin: 0 auto;
  background-repeat: no-repeat;

  p {
    font-family: ${({ theme }) => theme.fontFamilies.gotham};
  }
`
